import { render, staticRenderFns } from "./ContentTypeDetailView.vue?vue&type=template&id=78713636&scoped=true"
import script from "./ContentTypeDetailView.vue?vue&type=script&lang=js"
export * from "./ContentTypeDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78713636",
  null
  
)

export default component.exports